<template lang="pug">
template(v-if="variant === 'button'")
  .uiPriceComponent.button
    ui-button(
      color="blue"
      @click="onButtonClick"
    ) {{ text }} {{ price }} ₽
    .oldPrice(
      v-if="oldPrice"
    ) {{ oldPrice }}₽

template(v-else-if="variant === 'main'")
  .uiPriceComponent.main
    template(v-if="oldPrice")
      .text(v-if="text") {{ text }}
      .price {{ price }} ₽/год
      .oldPrice.main {{ oldPrice }} ₽
    template(v-else)
      .text {{ text }} {{ price }}₽

template(v-else)
  .uiPriceComponent.default
    template(v-if="oldPrice")
      .price {{ price }} ₽/год
      .oldPrice {{ oldPrice }} ₽
    template(v-else)
      .text {{ price }} ₽/год
</template>

<script setup>
// eslint-disable-next-line
defineProps({
  variant: {
    type: String,
    default: null // main | button
  },
  text: {
    type: String,
    default: null
  },
  price: {
    type: [Number, String],
    required: true
  },
  oldPrice: {
    type: [Number, String],
    default: null
  }
})

// eslint-disable-next-line
const emits = defineEmits(['buttonClick'])
// eslint-disable-next-line
const onButtonClick = () => {
  emits('buttonClick')
}
</script>

<style lang="sass" scoped>
.uiPriceComponent
  display: flex
  flex-direction: column
  .oldPrice
    text-decoration: line-through
    color: $cDarkGrey
  &.main
    @media (max-width: $XXXLWidth)
      align-items: center
      text-align: center
    .price
      color: $cDarkBlue
      font-size: 46px
      line-height: 58px
      font-family: GolosTextWebDemiBold, serif
      @media (max-width: $XXSWidth)
        font-size: 36px
    .oldPrice
      font-size: 28px
      @media (max-width: $XXSWidth)
        font-size: 22px
    .text
      font-size: 30px
      font-family: GolosTextWebDemiBold, serif
      @media (max-width: $XXSWidth)
        font-size: 22px
  &.button
    flex-direction: row
    align-items: center
    gap: 20px
    .oldPrice
      text-align: right
      @include font('t16-medium')
  &.default
    flex-direction: row
    align-items: center
    gap: 13px
    .price
      color: $cLightBlue
      background-color: $cBackground
      padding: 4px 12px
      border-radius: 6px
      @include font('t18-demibold')
    .oldPrice
      @include font('t14-regular')
    .text
      @include font(t18-demibold)
</style>
